(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function startCountdown(el) {
    const endStr = el.getAttribute('data-end');
    const end = Date.parse(endStr);
    if (!end || Number.isNaN(end)) return;

    function tick() {
      const now = Date.now();
      let diff = end - now;

      if (diff <= 0) {
        el.textContent = '0d 00h 00m 00s';
        return;
      }

      const days = Math.floor(diff / 86400000);
      diff %= 86400000;

      const hours = Math.floor(diff / 3600000);
      diff %= 3600000;

      const minutes = Math.floor(diff / 60000);
      diff %= 60000;

      const seconds = Math.floor(diff / 1000);

      // Formato: 5d 03h 12m 08s
      el.textContent = `${days}d ${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
    }

    tick();
    setInterval(tick, 1000);
  }

  function init() {
    document.querySelectorAll('.reval-countdown:not([data-initialized])').forEach((el) => {
      el.setAttribute('data-initialized', '1');
      startCountdown(el);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
